package com.milta.core.appconfig

/**
 * Simple in-memory cache around [AppConfigApi.getAppConfig] — at most one successful GET per app
 * launch, reused by every screen afterward. A failed fetch (offline, 5xx, ...) is NOT cached: it
 * falls back to `true` for that call only, so a later call (e.g. the next screen opened) gets a
 * chance to retry rather than being stuck fail-open for the rest of the session. Fail-open is
 * deliberate either way — RoutaR-dependent buttons must never disappear because of a network
 * hiccup, only because the backend explicitly answered `routarEnabled: false`.
 */
class AppConfigRepositoryImpl(private val api: AppConfigApi) : AppConfigRepository {

    private var cachedRoutarEnabled: Boolean? = null

    override suspend fun isRoutarEnabled(): Boolean {
        cachedRoutarEnabled?.let { return it }
        return runCatching { api.getAppConfig().routarEnabled }
            .onSuccess { cachedRoutarEnabled = it }
            .getOrDefault(true)
    }
}
